import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { Component, OnInit, ViewChild } from "@angular/core";
import { ToolEngraveModalComponent } from "@app/tool/components/tool-engrave-modal/tool-engrave-modal.component";
import tasks from "@app/shared/mock-them-all/tasks";
import grouperDropdownItems from "@app/shared/mock-them-all/grouper-list-dropdown";
import dropdownItems from '@app/shared/mock-them-all/assignation-dropdown-items';
import accordionItems from "@app/shared/mock-them-all/accordion-items";
import photos from "@app/shared/mock-them-all/photos";
import ticket from "@app/shared/mock-them-all/ticket-data";
import {
    StrainGageConfigurationModalComponent
} from "@app/strain/common/components/measurement-forms/strain-gage-configuration-modal/strain-gage-configuration-modal.component";
import { StrainMeasurementImage } from "@app/strain/common/models/view-measurement-models/strain-measurement.image";
import { AppUtils } from "@app/shared/util/app.utils";
import { LineLocation } from "@models/line-location.model";
import { ToastsManager } from "@app/shared/util/toastr.service";
import { TreeNode } from "primeng/api";
import { ScrollListItemModel } from "@components/scroll-list/models/scroll-list-item.model";
import { Task, TaskStatus } from "@app/maintenance/components/task/task.model";

@Component({
    selector: "app-demo",
    templateUrl: "./demo.component.html",
    styleUrls: ["./demo.component.scss"],
})
export class DemoComponent implements OnInit {

    @ViewChild(StrainGageConfigurationModalComponent, {static: true}) gageConfiguration: StrainGageConfigurationModalComponent;
    @ViewChild(ToolEngraveModalComponent, {static: true}) toolEngrave: ToolEngraveModalComponent;
    form: UntypedFormGroup;
    showValidations = false;
    items = [
        {id: 1, name: "Item 1", value: "Value 1", icon: 'star'},
        {id: 2, name: "Item 2", value: "Value 2", icon: 'star'},
        {id: 3, name: "Item 3", value: "Value 3", icon: 'star'},
    ];
    targetItems = [
        {id: 4, name: "Item 4", value: "Value 4"},
    ];
    tabs = [
        {
            link: 'tab1',
            active: true,
            label: 'Tab 1'
        },
        {
            link: 'tab2',
            active: false,
            label: 'Tab 2'
        },
        {
            link: 'tab3',
            active: false,
            label: 'Tab 3'
        },
    ]

    fabItems = [
        {
            tooltipOptions: {
                tooltipLabel: "Edit",
                tooltipPosition: 'left'
            },
            icon: 'pi pi-pencil',
            command: () => {
                this.toastr.info('Add');
            }
        },
        {
            tooltipOptions: {
                tooltipLabel: "Refresh",
                tooltipPosition: 'left'
            },
            icon: 'pi pi-refresh',
            command: () => {
                this.toastr.info('Update');
            }
        },
        {
            tooltipOptions: {
                tooltipLabel: "Delete",
                tooltipPosition: 'left'
            },
            icon: 'pi pi-trash',
            command: () => {
                this.toastr.info('Delete');
            }
        },
    ];
    public lineLocations: LineLocation[];

    mockTasks: any[] = [];

    task = new Task({
        id: 1,
        identifier: 'BRA_BRA_BRA',
        name: "Cleaning with rubbing alcohol",
        description: "Pocedure to clean tools with alcohol \r Step1 -> .............1..............................2.......................3...................4..............5  \r Lorem, ipsum dolor sit amet consectetur adipisicing elit. Labore quod reiciendis exercitationem adipisci repellat impedit? Debitis voluptas aspernatur nemo ducimus incidunt, excepturi fugit recusandae commodi nihil ex beatae consequuntur vero.",
        status: TaskStatus.NEW,
        canStart: true
    });

    tasks = tasks;
    grouperDropdownItems = grouperDropdownItems;
    dropdownItems = dropdownItems;
    accordionItems = accordionItems;
    photos = photos;
    ticket = ticket;

    measurementImages: StrainMeasurementImage;

    selectedFile: TreeNode;
    files = [
        {label: 'View', icon: 'pi pi-search', command: (event) => this.viewFile(this.selectedFile)},
        {label: 'Unselect', icon: 'pi pi-times', command: (event) => this.unselectFile()}
    ];
    treeDisplayTools: any[] = [
        {
            name: 'Some name',
            label: 'some label',
            data: 'some data',
            icon: 'fa-cog',
            children: [
                {
                    name: 'Some kid 1',
                    label: 'some label',
                    data: 'some data',
                    icon: 'fa-cog',
                },
                {
                    name: 'Some kid 2',
                    label: 'some label',
                    data: 'some data',
                    icon: 'fa-cog',
                },
            ]
        },
        {
            name: 'Some name 2',
            label: 'some label 2',
            data: 'some data',
            icon: 'fa-cog'
        },
    ];
    listboxItems = Array(20).fill(null).map(index => {
        return {id: index, label: `Label ${index}`, name: `Name ${index}`, value: `Value ${index}`};
    })
    scrollListItem = new ScrollListItemModel({
            id: 1,
            title: 'Some Item',
            subTitle: 'Some Subtitle',
            icon: 'fa-plus',
            description: 'Some description',
            item: 'smth',
            selected: false,
            highlighted: false
        }
    );

    constructor(private toastr: ToastsManager) {
    }

    openEngraveTool() {
        this.toolEngrave.open();
    }

    openGageConfigurationModal() {
        this.gageConfiguration.open(this.measurementImages);
    }

    onDeletePhoto = (photo: any) => this.photos = this.photos.filter(item => item.id !== photo.id);

    onGageSave(configuration: any) {
        this.measurementImages = configuration;
    }

    ngOnInit(): void {
        this.form = new UntypedFormGroup({
            text: new UntypedFormControl("", Validators.required),
            number: new UntypedFormControl(0, Validators.required),
            duration: new UntypedFormControl(220, Validators.required),
            date: new UntypedFormControl(new Date(), Validators.required),
            dropdown: new UntypedFormControl(null, Validators.required),
            multiDropdown: new UntypedFormControl([], [AppUtils.arrayLengthValidator(1, 2)]),
            switch: new UntypedFormControl(null, Validators.required),
            checkbox: new UntypedFormControl(null, Validators.required),
            multi: new UntypedFormControl([]),
            range: new UntypedFormControl(null),
            textarea: new UntypedFormControl("", Validators.required),
            autocomplete: new UntypedFormControl(
                {id: 2, name: "X"},
                Validators.required
            ),
            picklist: new UntypedFormControl([], Validators.required),
            listbox: new UntypedFormControl(null, Validators.required),
        });
        this.mockTasks = Object.assign([], tasks);
    }


    control(name: string) {
        return this.form.controls[name] as UntypedFormControl;
    }

    getFile(item) {
        const blob = AppUtils.buildBlobFromDataString(item.data);
        return new File([blob], item.name, {type: item.contentType});
    }

    onTabClick(tabs: any[]) {
        this.tabs = tabs;
    }

    onToast(type: string) {
        switch (type) {
            case 'info':
                this.toastr.info('Info message', 'Info');
                break;
            case 'success':
                this.toastr.success('Success message', 'Success');
                break;
            case 'danger':
                this.toastr.error('Danger message', 'Danger');
                break;
            case 'warning':
                this.toastr.warning('Warning message', 'Warning');
                break;
        }
    }

    selectCarouselFiles($event: any) {

    }

    viewFile(file: TreeNode) {
    }

    unselectFile() {
    }

    onSelect($event: MouseEvent) {

    }
}
